<template>
  <div class="clue-info">
    <Back title="线索详情" back="/clue/clueList"></Back>
    <main>
      <div class="main">
        <section class="text-item">
          <h1 class="van-hairline--bottom">客户信息</h1>
          <div class="text-content">
            <p>客户名称：{{ clueInfo.tenantName || "-" }}</p>
            <p>联&nbsp;&nbsp;系&nbsp;&nbsp;人：{{ clueInfo.tenantUserName || "-" }}</p>
            <p>联系电话：<span class="theme-color" @click="tel(clueInfo.tenantUserMobile)">{{ clueInfo.tenantUserMobile ||
              "-" }}</span></p>
            <p>客户状态：<span :style="{ color: clueStatusColorObj[clueInfo.clueStatus] }">{{
              clueStatusObj[clueInfo.clueStatus] || "-" }}</span>
            </p>
            <p>客户等级：{{ turnoverOddsObj[clueInfo.turnoverOdds] || "-" }}</p>
            <p>客户行业：{{ clueInfo.industryName || "-" }}</p>
            <p>联系人职位：{{ clueInfo.positionName || "-" }}</p>
            <p>联系人微信号：{{ clueInfo.userWx || "-" }}</p>
            <p>客户税收：{{ clueInfo.taxation || "-" }}</p>
            <p>现办公室地址：{{ clueInfo.officeAddress || "-" }}</p>
          </div>
        </section>
        <section class="text-item">
          <h1 class="van-hairline--bottom">需求信息</h1>
          <div class="text-content">
            <p>意向园区：{{ clueInfo.projectName || "-" }}</p>
            <p>需求面积：{{ clueInfo.requiredAreaRangeName || "-" }}</p>
            <p>意向区域：{{ clueInfo.hotAreaName || "-" }}</p>
            <p>期望价格：
              {{ clueInfo.requiredUnitPriceMin }} ~ {{ clueInfo.requiredUnitPriceMax }}
              {{ pricingUnitObj[clueInfo.requiredPricingUnit] }}
            </p>
            <p>其他意向竞品：{{ clueInfo.elseProject || "-" }}</p>
            <p>预计用房时间：{{ clueInfo.expectSignDate || "-" }}</p>
            <p>选址目的：{{ clueInfo.selectPurposeName || "-" }}</p>
            <p>核心需求：{{ clueInfo.coreNeedName || "-" }}</p>
            <p>办公员工人数：{{ clueInfo.officeStaffCount || "-" }}</p>
            <p>需求备注：{{ clueInfo.remark || "-" }}</p>
          </div>
        </section>
        <section class="text-item">
          <h1 class="van-hairline--bottom">招商渠道信息</h1>
          <div class="text-content">
            <p>招商部门：{{ clueInfo.deptName || "-" }}</p>
            <p>招商经理：{{ clueInfo.consultantName || "-" }}</p>
            <p>来源渠道：{{ clueInfo.channelTypeName || "-" }}</p>
            <p>合伙人：{{ clueInfo.partnerName || "-" }}</p>
            <p>渠道证明图：
              <van-image v-for="(i, index) in changeFileList(clueInfo.fileList).imgList" :key="i.fileId" width=".48rem"
                height=".48rem" :src="i.fileUrl" @click="
                  ImagePreview(changeFileList(clueInfo.fileList).imgViewList, index)
                  " />

            </p>
          </div>
        </section>
        <section class="text-item">
          <h1 class="van-hairline--bottom">客户时间线</h1>
          <div>
            <van-steps class="follow-list" direction="vertical" :active="0" active-color="#333">
              <van-step v-for="item in timelineDtoList" :key="item.recordTime">
                <div class="follow-item">
                  <span>{{ changeDate(item.recordTime, 1) }}</span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span>{{ item.recordUserName }}</span>
                </div>
                <div class="follow-item">
                  <span class="trace-type">{{ traceTypeObj[item.traceType] }}</span>
                  <div class="trace-right">
                    <div v-if="item.traceType == 1">
                      <div>备注：{{ item.content }}</div>
                      <div v-if="item.fileList && item.fileList.length > 0">
                        <van-image class="image-item" v-for="(i, index) in changeFileList(item.fileList).imgList"
                          :key="i.fileId" width=".48rem" height=".48rem" :src="i.fileUrl" @click="
                            ImagePreview(changeFileList(item.fileList).imgViewList, index)
                            " />
                      </div>
                    </div>
                    <span v-if="item.traceType == 2">跟进备注：{{ item.content }}</span>
                    <span v-if="item.traceType == 3">新建线索</span>
                    <span v-if="item.traceType == 4">回访记录：{{ item.content }}</span>
                    <div v-if="item.traceType == 5">
                      <span>转交人：{{ item.beforeConsultName }} —> {{ item.afterConsultName }}</span>
                      <p>转交备注：{{ item.content }}</p>
                    </div>
                    <span v-if="item.traceType == 6">
                      客户状态：{{ clueStatusObj[item.beforeClueStatus] }} —> {{ clueStatusObj[item.afterClueStatus] }}
                    </span>
                  </div>
                </div>
              </van-step>
            </van-steps>
          </div>
        </section>
      </div>
      <div class="foot van-hairline--top">
        <van-button v-if="clueInfo.clueStatus == 1 || clueInfo.clueStatus == 2" class="size grey"
          @click="loseShow = true">转无效</van-button>
        <van-button v-if="clueInfo.clueStatus != 3" class="size orange" @click="onChange">转交</van-button>
        <!-- <van-button v-if="clueInfo.clueStatus != 3" class="size blue" @click="onEdit">编辑</van-button> -->
        <van-button class="size green" @click="onFollow">备注跟进</van-button>
      </div>
    </main>
    <van-popup class="form-lose" v-model="loseShow">
      <van-form @submit="onLoseSubmit">
        <div class="form-title">转无效</div>
        <van-cell-group>
          <van-field readonly required is-link v-model="loseReasonText" name="loseReasonText" label="流失原因"
            placeholder="请选择流失原因" :rules="[required]" @click="loseReasonShow = true" />
        </van-cell-group>
        <div class="form-btn">
          <van-button round block type="info" native-type="submit">保 存</van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- 流失原因弹框 -->
    <van-popup v-model="loseReasonShow" round position="bottom">
      <van-picker show-toolbar @cancel="loseReasonShow = false" :columns="loseReasonList" value-key="codeLabel"
        @confirm="onFinishLoseReasonShow" />
    </van-popup>
  </div>
</template>

<script>
import Back from "@/components/back";
import { turnoverOddsObj, clueStatusObj, clueStatusColorObj, pricingUnitObj, traceTypeObj } from "@/db/clue";
import { getTimelineDtoList, getLoseReasonList, getClueChange } from "@/api/clue/clue";
import { changeDate, changeFileList } from "@/utils/utils";
import { ImagePreview, Toast } from "vant";
import { required } from "@/utils/rules"
export default {
  components: { Back },
  data() {
    return {
      turnoverOddsObj,
      clueStatusObj,
      clueStatusColorObj,
      pricingUnitObj,
      traceTypeObj,
      changeFileList,
      changeDate,
      clueId: this.$route.query.clueId,
      clueInfo: "",
      timelineDtoList: "",
      changeShow: false,
      // 转流失
      loseShow: false,
      required,
      loseReasonText: '',
      loseReason: '',
      loseReasonList: [],
      loseReasonShow: false,
    };
  },
  created() {
    this.getTimelineDtoList();
    this.getLoseReasonList();
  },
  methods: {
    // 【监听】拨打电话
    tel(tel) {
      window.location.href = "tel://" + tel;
    },

    // 【请求】获取线索跟进详情
    getTimelineDtoList() {
      let clueId = this.clueId;
      getTimelineDtoList(clueId).then((res) => {
        if (res.success) {
          this.clueInfo = res.data.clueInfoDto
          this.timelineDtoList = res.data.timelineDtoList;
        }
      });
    },

    // 【请求】获取流失原因
    getLoseReasonList() {
      getLoseReasonList().then((res) => {
        if (res.success) {
          this.loseReasonList = res.list
        }
      });
    },

    // 【监听】客户转交
    onChange() {
      this.$router.push("/clue/clueChange?clueId=" + this.clueId);
    },

    // 【监听】客户编辑
    onEdit() {
      this.$router.push("/clue/clueEdit?clueId=" + this.clueId);
    },

    // 【监听】客户跟进
    onFollow() {
      this.$router.push("/clue/clueFollow?clueId=" + this.clueId);
    },

    // 【监听】图片预览
    ImagePreview(images, index) {
      ImagePreview({
        images: images,
        startPosition: index,
      });
    },

    // 【监听】转无效
    onLoseSubmit() {
      let data = {
        clueId: this.clueInfo.clueId,
        deptId: this.clueInfo.deptId,
        clueStatus: 4,
        transferType: 2,
        loseReason: this.loseReason,
      };
      getClueChange(data).then(res => {
        if (res.success) {
          Toast(res.msg);
          this.loseShow = false;
          this.getTimelineDtoList();
        } else {
          Toast(res.msg);
        }
      })
    },

    // 【监听】确认流失原因
    onFinishLoseReasonShow(data) {
      this.loseReasonText = data.codeLabel;
      this.loseReason = data.codeValue;
      this.loseReasonShow = false;
    }

  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/theme";

.clue-info {
  height: 100%;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1;
}

.foot {
  padding: 0.1rem;
  display: flex;
  justify-content: space-around;

  .size {
    width: 100%;
    height: 0.36rem;
    margin: 0 0.1rem;
  }

  .grey {
    color: #999;
    background: #eee;
    border-color: #999;
  }

  .orange {
    color: #e6a23c;
    background: #fdf6ec;
    border-color: #f5dab1;
  }

  .blue {
    color: #409eff;
    background: #ecf5ff;
    border-color: #b3d8ff;
  }

  .green {
    color: #67c23a;
    background: #f0f9eb;
    border-color: #c2e7b0;
  }
}

.text-item {
  border-bottom: 0.15rem #f1f2f6 solid;

  h1 {
    padding: 0.1rem;
    display: flex;
    align-items: center;
  }

  .text-icon {
    display: inline-block;
    background: #1989fa;
    width: 0.04rem;
    border-radius: 0 0.04rem 0.04rem 0;
    margin-right: 0.1rem;
    height: 0.16rem;
  }

  .text-content {
    padding: 0.1rem;
    font-size: 0.14rem;

    p {
      margin: 0.05rem 0;
    }
  }
}

.follow-item {
  display: flex;
  margin-bottom: 0.1rem;
}

.theme-color {
  font-weight: bold;
}

.trace-type {
  display: inline-flex;
  justify-content: center;
  align-content: center;
  width: .2rem;
  height: .2rem;
  line-height: .2rem;
  border-radius: 50%;
  border: 1px solid #2589FF;
  box-sizing: border-box;
  color: #2589FF;
  margin-right: 0.05rem;
}

.trace-right {
  flex: 1;
}

.form-lose {
  width: 80%;
}

.form-btn {
  padding: 0.15rem;
}

.form-title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.15rem;
}

.image-item {
  margin-right: .05rem;
}
</style>
